import { DocumentListDialog } from '@/components/DocumentListDialog';
import { useVendorGetById } from '@brainvaulttech/dgr-react-sdk';
import { useMemo } from 'react';

const VendorDocumentDialog = ({
  vendorId,
  onCloseClick,
  activeIndex = 0,
}: {
  vendorId: string;
  onCloseClick: () => void;
  activeIndex?: number;
}) => {
  const { data: vendorData, isLoading } = useVendorGetById(vendorId);
  const documentList = useMemo(() => {
    return (
      vendorData?.data.documents.map((document) => ({
        media: document.media!,
        name: document?.name,
      })) ?? []
    );
  }, [vendorData]);

  return (
    <DocumentListDialog
      onCloseClick={onCloseClick}
      activeIndex={activeIndex}
      documents={documentList.reverse()}
      isLoading={isLoading}
    />
  );
};

export default VendorDocumentDialog;
